import { IFormErrors } from '@interfaces/IFormsErrors';

export interface IEventsChangesState {
  isLoading: boolean;
  fileLoading: boolean;
  materialLoading: boolean;
  linkLoading: boolean;
  success: boolean;
  errors: IFormErrors | null;
}

export const initialEventsChangesState: IEventsChangesState = {
  isLoading: false,
  materialLoading: false,
  fileLoading: false,
  linkLoading: false,
  success: false,
  errors: null,
};
